import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  guid: null,
};

export const selectedAccessibleFarmerSlice = createSlice({
  name: "selectedAccessibleFarmer",
  initialState,
  reducers: {
    setSelectedAccessibleFarmer: (state, action) => {
      state.guid = action.payload;
    },
  },
});

export const { setSelectedAccessibleFarmer } =
  selectedAccessibleFarmerSlice.actions;

export const selectedAccessibleFarmerReducer =
  selectedAccessibleFarmerSlice.reducer;
